export class ShopPacksFiltersRequest {
  start_date_min_timestamp: number = null;
  start_date_max_timestamp: number = null;
}
